<template>
  <content-dialog
    :visible.sync="modalVisible"
    max-width="800px"
  >
    <!--<editor-fold desc="Dialog Header">-->
    <template slot="dialogTitle">
      <span v-if="baseDirty.id">
        Edit Base
      </span>
      <span v-else>
        Add New Base
      </span>
    </template>
    <!--</editor-fold>-->

    <!--<editor-fold desc="Form">-->
    <v-card-text :class="{'pa-5': !$vuetify.breakpoint.xsOnly }">
      <v-text-field
        v-model="baseDirty.name"
        outlined
        label="Name"
        placeholder="Base Name"
      />
      <v-text-field
        v-model="baseDirty.address"
        outlined
        label="Address"
        placeholder="Ilica 58, 10000 Zagreb"
      />
      <v-autocomplete
        v-model="baseDirty.country_id"
        outlined
        label="Select Country"
        :items="countries.data"
        :loading="countries.loading"
        item-value="id"
        item-text="name"
      />
    </v-card-text>
    <!--</editor-fold>-->

    <!--<editor-fold desc="Dialog Actions">-->
    <template slot="dialogActions">
      <v-btn
        v-if="baseDirty.id && $can('delete', 'Base')"
        small
        outlined
        color="error"
        @click="toggleConfirmationDialog(true)"
      >
        <v-icon
          left
          small
        >
          delete
        </v-icon>
        Delete
      </v-btn>
      <v-spacer />
      <v-btn
        text
        color="grey"
        @click="modalVisible = false"
      >
        Cancel
      </v-btn>
      <v-btn
        color="primary"
        :disabled="submitting"
        @click="submit"
      >
        <v-icon
          small
          left
        >
          check
        </v-icon>
        Save
      </v-btn>
    </template>
    <!--</editor-fold>-->

    <confirm-delete-dialog
      :visible.sync="deleteConfirmationDialogVisible"
      :submitting="deleting"
      text="Are you sure you want to delete this Base?"
      @confirmed="deleteBase"
    />
  </content-dialog>
</template>

<script>
  import { mapGetters } from 'vuex'
  import cloneDeep from 'lodash/cloneDeep'
  import Base from '@/models/Base'
  import ContentDialog from '@/components/helpers/Dialog'
  import deleteConfirmationMixin from '@/mixins/deleteConfirmationMixin'
  import ConfirmDeleteDialog from '@/components/helpers/ConfirmDeleteDialog'

  export default {
    name: 'BaseEditDialog',
    components: {
      ContentDialog,
      ConfirmDeleteDialog
    },
    mixins: [deleteConfirmationMixin],
    props: {
      visible: {
        type: Boolean,
        default: false
      },
      base: {
        type: Object,
        default: null
      }
    },
    data() {
      return {
        baseDirty: cloneDeep(Base.emptyModel),
        submitting: false
      }
    },
    computed: {
      modalVisible: {
        get: function () {
          return this.visible
        },
        set: function (value) {
          this.$emit('update:visible', value)
        }
      },
      ...mapGetters('settings', ['countries'])
    },
    watch: {
      base() {
        this.baseDirty = cloneDeep(this.base)
      }
    },
    methods: {
      submit() {
        this.$validator.validate().then(result => {
          if (result) this.save()
        })
      },
      async save() {
        this.submitting = true

        const data = {
          address: this.baseDirty.address,
          country_id: this.baseDirty.country_id,
          name: this.baseDirty.name
        }

        try {
          let base = await Base.api.save(data, this.baseDirty.id)

          this.$store.dispatch('alert', {
            'text': 'Base saved',
            'color': 'success'
          })
          this.modalVisible = false
          this.$emit(this.baseDirty.id ? 'base:updated' : 'base:created', base)
        } catch (e) {
          this.$store.dispatch('alert', {
            'text': 'Something went wrong',
            'color': 'error'
          })
        } finally {
          this.submitting = false
        }
      },
      async deleteBase() {
        this.deleting = true

        try {
          await Base.api.destroy(this.baseDirty.id)

          this.$store.dispatch('alert', {
            'text': 'Base deleted',
            'color': 'info'
          })
          this.modalVisible = false
          this.$emit('base:deleted', this.baseDirty.id)
        } catch (e) {
          this.$store.dispatch('alert', {
            'text': 'Something went wrong',
            'color': 'error'
          })
          throw e
        } finally {
          this.deleteConfirmationDialogVisible = false
          this.deleting = false
        }
      }
    }
  }
</script>
